const baseStyle = {
    container: {
        display: "flex",
        alignItems: "flex-start",
        p: 4,
        borderRadius: "lg",
        color: "greyscale.700",
    },
    icon: { mr: 2 },
};
const variants = {
    primary: {
        container: {
            background: "greyscale.300",
        },
        icon: { color: "primary.500" },
    },
    secondary: {
        container: {
            border: "1px solid",
            borderColor: "greyscale.400",
            bg: "greyscale.100",
        },
        icon: { color: "greyscale.400" },
    },
    danger: {
        container: {
            border: "1px solid",
            borderColor: "danger.300",
            background: "danger.100",
        },
        icon: { color: "danger.500" },
    },
    warning: {
        container: {
            border: "1px solid",
            borderColor: "warning.200",
            background: "warning.100",
        },
        icon: { color: "warning.500" },
    },
};
const InfoBox = { baseStyle, variants };
export default InfoBox;
